// extracted by mini-css-extract-plugin
module.exports = {"navbar":"A2bL1","navbtn":"s70Qz","year":"_35J9R","month":"_34Hpq","prev":"_1r-nL","next":"_2a-un","current-month-year":"_3i6zG","currentMonthYear":"_3i6zG"};